<template>
    <div class="pkg-content">
        <!-- 按钮-->
        <div class="msg">
            <el-card class="box-card card1">
                <div class="search">
                    <el-button @click="goBack()">返回</el-button>
                    <el-button v-show="!isView" @click="save('0')" type="primary">保存</el-button>
                    <el-button v-show="!isView && checkPub()" @click="publish('1')" type="primary">发布</el-button>
<!--                    <el-button v-show="isView && (formData.managedata.workStatus === '0' || formData.managedata.workStatus === '2')" type="primary" @click="goEdit">编辑</el-button>-->
<!--                    <el-button v-show="isView && (formData.managedata.workStatus === '0' || formData.managedata.workStatus === '2')" @click="publish('2')" type="primary">发布</el-button>-->
<!--                    <el-button v-show="isView && formData.managedata.workStatus === '1'" type="primary" @click="soldOut">下架</el-button>-->
                </div>
            </el-card>
        </div>
        <!-- 基本信息 -->
        <div class="msg">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>基本信息</span>
                </div>
                <div>
                    <el-form
                            label-position="top"
                            :model="formData.managedata"
                            :rules="dataRule"
                            ref="dataForm">
                        <el-form-item prop="competitionCode" label="大赛ID">
                            <el-row>
                                <el-col :span="17">
                                    <el-input v-model="formData.managedata.competitionCode"
                                              :maxlength="50"
                                              :disabled="true"
                                              placeholder="系统自动生成"
                                              show-word-limit></el-input>
                                </el-col>

                            </el-row>
                        </el-form-item>
                        <el-form-item prop="associatedZoneDTO" label="关联专区">
                            <el-row>
                                <el-col :span="17">
                                    <el-button type="primary" @click="themeData()">关联专区</el-button>
                                </el-col>

                            </el-row>
                            <el-row>
                                <el-col v-if="formData.managedata.associatedZoneDTO.length>0">
                                    <el-card class="box-card">
                                        <el-tag
                                                :key="theme.id"
                                                v-for="theme in formData.managedata.associatedZoneDTO"
                                                closable
                                                style="margin-bottom: 5px"
                                                :disable-transitions="false"
                                                @close="handleClose2(theme)">
                                            {{theme.name}}
                                        </el-tag>
                                    </el-card>
                                </el-col>
                            </el-row>
                        </el-form-item>
                        <el-form-item prop="competitionTagDTOS" label="标签">
                            <div>
                                <el-tag
                                        style="margin-bottom: 5px"
                                        :key="tag.tagContent"
                                        v-for="(tag, index) in formData.managedata.competitionTagDTOS"
                                        :closable="!isView"
                                        :disable-transitions="false"
                                        @close="handleClose(index)">
                                    {{tag.tagContent}}
                                </el-tag>
                                <el-input
                                        v-if="formData.managedata.competitionTagDTOS.length===0"
                                        style="width: 200px;margin-bottom: 5px"
                                        class="input-new-tag"
                                        v-model="inputValue"
                                        placeholder="请输入标签"
                                        :maxlength="50"
                                        @keyup.enter.native="handleInputConfirm"
                                        @blur="handleInputConfirm"
                                >
                                </el-input>
                                <el-tag
                                        :key="tempTag.id"
                                        v-for="tempTag in tempTags"
                                        :closable="!isView"
                                        :disable-transitions="false"
                                        @close="handleClose3(tempTag)">
                                    {{tempTag.name}}
                                </el-tag>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
            </el-card>
        </div>
        <!-- 模块内容设置 -->
        <div class="msg">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>模块内容设置</span>
                </div>
                <div class="introduce-container">
                    <div class="introduce-list">
                        <template v-for="(introduce, index) in formData.managedata.competitionModuleDTOS">
                            <div :key="index" class="introduce-item">
                                <el-row>
                                    <el-col :span="1">
                                        <div class="content">模块</div>
                                    </el-col>

                                    <el-col :span="20">
                                        <!--模块输入-->
                                        <div>
                                            <el-row>
                                                <el-col :span="15">
                                                    <el-input v-model="introduce.moduleName"
                                                              maxlength="10"
                                                              placeholder="请输入不超过10个字的文字信息"
                                                              @input="Input( $event,index)"></el-input>
                                                </el-col>
                                                <el-col :span="2">
                                                    <el-button v-if="formData.managedata.competitionModuleDTOS.length>1" type="text" @click="delModule(index)">删除模块</el-button>
                                                </el-col>
                                            </el-row>
                                        </div>

                                        <br/>
                                        <!--模块图片-->
                                        <div class="media-warpper content">
                                            <el-upload class="upload-demo"
                                                       :headers="headers"
                                                       action="#"
                                                       accept=".jpg,.png,.jpeg"
                                                       :http-request="imgUpload"
                                                       :show-file-list="false"
                                                       :disabled="isView"
                                                       :before-upload="(file)=>beforeImageUpload(file, index,-1)">
                                                <div class="media-warpper">
                                                    <div v-if="formData.managedata.competitionModuleDTOS[index].backGround">
                                                        <img alt="" :src="formData.managedata.competitionModuleDTOS[index].backGround">
                                                    </div>
                                                    <em v-else class="el-icon-plus avatar-uploader-icon"></em>
                                                    <div v-if="!formData.managedata.competitionModuleDTOS[index].backGround" class="el-upload__text" style="width: 100%;color: #b5b5b5">上传图片</div>
                                                    <div v-if="formData.managedata.competitionModuleDTOS[index].backGround && !isView " class="remove-icon" @click.stop="removeImg">
                                                        <em class="el-icon-close"></em>
                                                    </div>
                                                </div>
                                            </el-upload>
                                        </div>

                                        <br/>
                                        <!--H5链接 选择-->
                                        <div>
                                            <el-radio-group v-model="introduce.moduleType" @change="radioChange($event,index)">
                                                <el-radio :label="'2'">H5链接</el-radio>
                                            </el-radio-group>
                                        </div>

                                        <!--H5链接输入-->
                                        <div v-if="introduce.moduleType === '2'">
                                            <br/>
                                            <el-row>
                                                <el-col :span="2"><div>H5链接</div></el-col>
                                                <el-col :span="13">
                                                    <el-input v-model="introduce.h5Url"
                                                              placeholder="请输入"
                                                              :disabled="introduce.moduleType !== '2'"
                                                              maxlength="2000"
                                                              ></el-input>
                                                </el-col>
                                            </el-row>
                                        </div>

                                        <br/>
                                        <!--文本选择-->
                                        <div>
                                            <el-radio-group v-model="introduce.moduleType" @change="radioChange($event,index)">
                                                <el-radio :label="'1'">文本</el-radio>
                                            </el-radio-group>
                                        </div>

                                        <!--文本-->
                                        <div class="introduce-container" v-if="introduce.moduleType == '1'">
                                            <div class="introduce-list">
                                                <template v-for="(v, i) in introduce.competitionFiles">
                                                    <div :key="i" class="introduce-item">
                                                        <template v-if="v.fileType == '50'">
                                                            <el-row>
                                                                <el-col :span="10" class="content">
                                                                    <el-input type="textarea" v-model="v.fileUrl"
                                                                              maxlength="500"
                                                                              placeholder="请输入文本，最多500字"
                                                                              show-word-limit
                                                                              :disabled="isView"
                                                                              @input="Input( $event,index)"></el-input>
                                                                    <em v-if="!isView" class="el-icon-remove remove-icon" @click="delIntroduce(index,i)"></em>
                                                                </el-col>
                                                            </el-row>
                                                        </template>
                                                        <template v-else-if="v.fileType == '10'">
                                                            <div class="media-warpper content">
                                                                <el-upload
                                                                        ref="introduce-img"
                                                                        :headers="headers"
                                                                        action="#"
                                                                        accept=".jpg,.png,.jpeg"
                                                                        :http-request="imgUpload"
                                                                        :show-file-list="false"
                                                                        :disabled="isView"
                                                                        :before-upload="(file)=>beforeImageUpload(file,index,i)">
                                                                    <img alt="" v-if="v.fileUrl" class="avatar">
                                                                    <em v-else class="el-icon-plus avatar-uploader-icon"></em>
                                                                    <div v-if="!v.fileUrl" >添加图片</div>
                                                                </el-upload>
                                                                <img alt="" :src="v.fileUrl">
                                                                <em v-if="!isView" class="el-icon-remove remove-icon" @click="delIntroduce(index,i)"></em>
                                                            </div>
                                                        </template>
                                                        <template v-else-if="v.fileType == '20'">
                                                            <div style="display: flex;">
                                                                <div class="media-warpper content">
                                                                    <upload-file
                                                                            v-if="!v.fileUrl"
                                                                            ref="refVideo"
                                                                            @fileUrlData="(val)=>fileUrlData(val,index,i)"
                                                                            @fileId="fileId"
                                                                    ></upload-file>
                                                                    <video v-if="v.fileUrl" :src="v.fileUrl" controls/>
                                                                </div>
                                                                <div class="media-warpper content1" >
                                                                    <div v-if="!v.fileUrl">视频上传完成后可点击图片自定义视频头图</div>
                                                                    <img alt="" v-if="v.fileUrl" :src="v.fileCoverUrl" @click="modifyCoverImg(index,i)">
                                                                </div>
                                                                <em v-if="!isView" class="el-icon-remove remove-icon" @click="delIntroduceVideo(index,i)"></em>
                                                            </div>

                                                        </template>
                                                    </div>
                                                </template>
                                            </div>
                                            <div v-if="!isView" class="bottom-btns">
                                                <em class="el-icon-circle-plus" @click="addText(index)">添加文本</em>
                                                <em class="el-icon-circle-plus" @click="addImage(index)">添加图片</em>
                                                <em class="el-icon-circle-plus" @click="addVideo(index)">添加视频</em>
                                            </div>
                                            <br>
                                            <div v-if="!isView" style="line-height: 26px">
                                                文本不能超过500字，图片不能大于20MB，格式为png，jpeg及jpg<br>视频不能超过1G，格式为mp4，mov。
                                            </div>
                                        </div>

                                        <!--知乎-->
                                        <br/>
                                        <div>
                                            <el-row>
                                                <el-radio-group v-model="introduce.moduleType" @change="radioChange($event,index)">
                                                    <el-radio :label="'3'">问吧</el-radio>
                                                </el-radio-group>
                                            </el-row>
                                            <!--开始-结束日期-->
                                            <br>
                                            <el-row type="flex" align="middle" justify="end" :gutter="20" v-if="introduce.moduleType == '3'">
                                                <el-col :span="4">
                                                    数据统计起止时间
                                                </el-col>
                                                <el-col :span="19">
                                                    <el-date-picker v-model="introduce.startStopDate"
                                                                    type="daterange"
                                                                    value-format="yyyy-MM-dd"
                                                                    start-placeholder="开始时间"
                                                                    end-placeholder="结束时间"
                                                                    :clearable="true"
                                                                    style="width: 100%">
                                                    </el-date-picker>
                                                </el-col>
                                            </el-row>
                                            <!--是否限制参赛-->
                                            <br>
                                            <el-row type="flex" align="middle" justify="end" :gutter="20" v-if="introduce.moduleType == '3'" >
                                                <el-col :span="4">是否限制参赛</el-col>
                                                <el-col :span="19">
                                                    <template>
                                                        <el-radio v-model="introduce.isRestriction" label="1">限制</el-radio>
                                                        <el-radio v-model="introduce.isRestriction" label="2" @change="noRestriction(index)">不限制</el-radio>
                                                    </template>
                                                </el-col>
                                            </el-row>
                                            <!--参赛用户-->
                                            <br>
                                            <el-row type="flex" align="middle" justify="end" :gutter="20" v-if="introduce.moduleType == '3' && introduce.isRestriction == '1'">
                                                <el-col :span="4"><div class="content">参赛用户</div></el-col>
                                                <el-col :span="19">
                                                    <el-button class="tool-button" type="primary" @click="selectGroup(introduce.groupDTOS,index)">选择</el-button>
                                                </el-col>
                                            </el-row>
                                            <br>
                                            <el-row type="flex" align="middle" justify="end" v-if="introduce.moduleType == '3' && introduce.isRestriction == '1'" >
                                                <el-col :span="19">
                                                    <div class="group-content ">
                                                        <div class="group-card"
                                                             v-for="(item, j) in introduce.groupDTOS"
                                                             :key="'group' + j">
                                                            {{ item.groupName }}
                                                            <span class="group-card-close" @click="delGroup(index,j)">x</span>
                                                        </div>
                                                    </div>
                                                </el-col>

                                            </el-row>

                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </template>

                        <br>
                        <el-button type="text" @click="addTemplate">添加模块</el-button>
                        <br>

                    </div>
                </div>
            </el-card>
        </div>
        <upload-img ref="refImg" @refreshImg="refreshCoverImg"></upload-img>

        <!-- 选择专区 -->
        <el-dialog title="选择专区"
                   :visible.sync="isShow"
                   width="700px">
            <el-row style="height: 34px; margin-bottom: 20px">
                <el-col :span="3">
                    <p style="margin: 0; line-height: 34px">专区名称</p>
                </el-col>
                <el-col :span="11">
                    <el-input v-model="themeFrom.themeName" :clearable="true"></el-input>
                </el-col>
                <el-col :span="10" style="text-align: right">
                    <el-button type="primary" @click="findTheme()">查找</el-button>
                </el-col>
            </el-row>
            <div>
                <el-table :data="themeFrom.themeList"
                          ref="multipleTable"
                          highlight-current-row
                          border
                          v-loading="dataListLoading"
                          row-key="id"
                          height=280
                          @select="selectRedio"
                          @select-all="selectRedioAll"
                          >
                    <el-table-column type="selection"
                                     header-align="center"
                                     align="center"
                                     width="50"
                                     :selectable='checkboxT'
                                     :reserve-selection="true">
                    </el-table-column>
                    <!-- 专题名称 -->
                    <el-table-column prop="name"
                                     label="专区名称"
                                     width="305"
                                     header-align="center"
                                     show-overflow-tooltip
                                     align="center"></el-table-column>
                    <!-- 创建人 -->
                    <el-table-column prop="createUserName"
                                     label="创建人"
                                     width="304"
                                     header-align="center"
                                     show-overflow-tooltip
                                     align="center">
                    </el-table-column>
                </el-table>
                <el-pagination @size-change="pageSizeChangeHandle"
                               @current-change="pageCurrentChangeHandle"
                               :current-page="themeFrom.page"
                               :page-sizes="[10, 20, 50, 100]"
                               :page-size="themeFrom.limit"
                               style="text-align: right"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="themeFrom.total">
                </el-pagination>
                <div style="text-align: right; margin-top: 20px">
                    <el-button @click="isShow = false">取 消</el-button>
                    <el-button type="primary" @click="selectTheme()">选 择</el-button>
                </div>
            </div>
        </el-dialog>

        <!--选择组群-->
        <competition-group
                :dialogShow="dialogShowGroup"
                v-if="dialogShowGroup"
                @closeHandle="closeGroup"
                @saveGroup="saveGroup"
                :groupChose="groupList"
               />
    </div>
</template>

<script>
    import Vue from 'vue'
    import UploadFile from "../../grow/theme/uploadFile";
    import axios from 'axios'
    import FileMd5 from '../../creationSharing/js/models/file-md5'
    import UploadImg from "./uploadImg";
    import CompetitionGroup from "./competitionGroup";
    export default {
        name: "competitionAdd",
        components: {CompetitionGroup, UploadImg, UploadFile},
        data() {
            return {
                themeStatus: "",
                remnant: 0,
                // 上传地址
                actionUrl: window.SITE_CONFIG['apiBaseURL'] + '/sys/config/imgUpload',
                server_config: window.SITE_CONFIG['apiBaseURL'] + '/grow/breakpointfile/appUpload',
                type: null,
                id: null,
                formData:{
                    managedata:{
                        id: '',
                        competitionCode: '', // 大赛id
                        associatedZoneDTO: [], // 专区id集合
                        associatedZone: [], // 专区id集合
                        competitionTagDTOS: [],   //标签集合
                        workStatus: "0",
                        competitionModuleDTOS:[{
                            moduleName: "", // 模块输入
                            backGround: "", // 添加图片
                            h5Url: "", //h5连接
                            moduleType: '2', // 选择h5还是文本
                            competitionFiles: [],
                            startStopDate: [], // 起止日期
                            isRestriction: '2', // 默认不限制
                            groupDTOS: [] // 限制群组
                        }]
                    }
                },
                // 参赛分组弹窗控件
                dialogShowGroup: false,
                indexGroup: 0,
                groupList:[],
                //标签相关
                tempTags: [],
                inputValue: '',
                // 校验
                dataRule: {
                    associatedZoneDTO: [
                        { required: true, message: "请选择关联专区", trigger: 'change', type: "array" }
                    ],
                    competitionTagDTOS: [
                        { required: true, message: "请输入标签，最多50字", trigger: 'blur', type: "array" }
                    ]
                },
                //话题图片下标
                introduceIndexImg: 0,
                textintroduceIndexImg: -1,
                fileCoverUrlIntroduceIndexImg: -1,
                // 视频
                videoId: '',
                /*****选专区字段数据*/
                isShow: false, // 弹窗显示
                dataListLoading : false,
                themeFrom: {  // 专区数据
                    showTag: false,
                    themeMultipleSelection: [], // 勾选专区
                    themeList: [], // 专区列表
                    list: [], // 被关联专区列表
                    page: 1,                    // 当前页码
                    limit: 10,                  // 每页数
                    total: 0,                   // 总数
                    themeName: '',              // 专区筛选
                    saveButton: false,
                }
            }
        },
        computed:{
            //是否为新增
            isAdd(){
                console.log('----isAdd---',this.type == "add")
                return this.type == "add"
            },
            //是否为查看
            isView(){
                console.log('----isView---',this.type == "view")
                return this.type == "view"
            },
            // 获取请求头
            headers: function headers () {
                let headersObj = {
                    token: Vue.prototype.getStorage(Vue.prototype.GLOBAL.TOKEN)
                }
                return headersObj
            }
        },
        // 生命周期 - 挂载完成（可以访问DOM元素）
        activated() {
            this.type = this.$route.query.type
            this.id = this.$route.query.id
            // this.getClassifyList()
            this.getInfo()
        },
        mounted() {

        },
        methods: {
            // 编辑按钮权限
            checkPub(){
            if(this.$hasPermission('joy:learning:megagame:pub')){
                return true
            }
            return false;
            },
            // 查询详情数据
            getInfo() {
                //清空表单
                if(this.isAdd){
                    //新增不访问接口
                    return
                }else {
                    // this.emptyFormData()
                }
                this.$request
                    .get(`/competition/competitionManage/select`+`?id=` + this.id  )
                    .then((res, total, code, data) => {
                        Object.getOwnPropertyNames(this.formData).forEach(key => {
                            let val = data.data[key]
                            val && (this.formData[key] = val)
                        })
                        // this.formData.managedata = data.data
                        this.formData.managedata.id = data.data.id
                        this.formData.managedata.competitionCode = data.data.competitionCode
                        // 专区转换
                        var associatedZoneDTO = []
                        var associatedZone = []
                        for(const key in data.data.associatedZoneMap){
                            var dto = {id : key,name:data.data.associatedZoneMap[key]}
                            var id =  key
                            console.log(key+","+data.data.associatedZoneMap[key])
                            associatedZoneDTO.push(dto)
                            associatedZone.push(id)
                        }
                        this.formData.managedata.associatedZoneDTO = associatedZoneDTO
                        this.formData.managedata.associatedZone = associatedZone
                        console.log(this.formData.managedata.associatedZone)
                        // 标签
                        this.formData.managedata.competitionTagDTOS = data.data.competitionTagDTOS
                        // 状态
                        this.formData.managedata.workStatus = data.data.workStatus
                        // 模块
                        this.formData.managedata.competitionModuleDTOS = data.data.competitionModuleDTOS
                        console.log(this.formData.managedata)
                    })
                    .catch(() => {
                    })
            },
            // 顶部发布按钮
            publish(val){
                console.log('-----publish----',val)

                // if (this.isAdd) {
                //     this.save('1')
                // }else {
                    this.singleActionHandler("发布", "/competition/competitionManage/updateStatus", this.id,1)
                // }
            },

            // 保存前判断是否必填
            saveData(val){
                //验证通过
                this.$request.post(`/competition/competitionManage/pcSave`, this.formData.managedata).then((data) => {
                    if (val=='0') {
                        this.$message({
                            message: "保存成功",
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.goBack()
                            }
                        })
                    } else {
                        this.$message({
                            message: "发布成功",
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.goBack()
                            }
                        })
                    }
                })
            },

            // 顶部保存按钮
            save(val){
                // 保存前专区数据处理
                var l = this.formData.managedata.associatedZoneDTO.length
                if (l > 0) {
                    var associatedZone = ""
                    this.formData.managedata.associatedZoneDTO.forEach((item,i)=>{
                        if ( i==0) {
                            associatedZone = item.id
                        }else {
                            associatedZone = associatedZone + "," + item.id
                        }
                    })
                    this.formData.managedata.associatedZone = associatedZone
                }else {
                    this.formData.managedata.associatedZone = ''
                }
                // 限制参赛数据处理
                this.formData.managedata.competitionModuleDTOS.forEach(item=>{
                    if (item.isRestriction === '2' || item.groupDTOS==null) {
                        item.groupDTOS = []
                    }
                })
                this.formData.managedata.workStatus = val

                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        if(this.savecheck(this.formData.managedata.competitionModuleDTOS)){
                            console.log(this.formData.managedata)
                            this.saveData(val)
                        }
                    }
                })
            },
            // 保存校验
            savecheck(value) {
                var flag = true
                // 校验必填项
                value.forEach((item,index)=>{
                    console.log(index,item)
                    if (item.moduleName==''||item.backGround=='') {
                        this.$message({
                            message: "请填写第"+(index+1)+"个模块中的必填项！",
                            type: 'warning',
                        })
                        flag = false
                    } else
                    if (item.moduleType=='2'&&item.h5Url=='') {
                        this.$message({
                            message: "请填写第"+(index+1)+"个模块中的H5链接！",
                            type: 'warning',
                        })
                        flag = false
                    } else
                    if (item.moduleType=='1'&&item.competitionFiles.length>0) {
                        item.competitionFiles.forEach((i,n)=>{
                            if (i.fileUrl=='') {
                                this.$message({
                                    message: "请填写第"+(index+1)+"个模块中的文本！",
                                    type: 'warning',
                                })
                                flag = false
                            }
                        })
                    }else if (item.moduleType=='1'&&item.competitionFiles.length==0) {
                        this.$message({
                            message: "请填写第"+(index+1)+"个模块中的文本！",
                            type: 'warning',
                        })
                        flag = false
                    }else
                    // 限制参赛组群
                    if (item.moduleType == '3' && item.isRestriction == '1' && item.groupDTOS.length == 0) {
                        this.$message({
                            message: "请选择第"+(index+1)+"个模块中的参赛用户！",
                            type: 'warning',
                        })
                        flag = false
                    }
                })
                return flag;
            },
            //单数据操作处理
            singleActionHandler(actionName, api, data,status){
                this.$confirm(`是否${actionName}该大赛?`, `${actionName}大赛`, {
                    type: 'warning'
                }).then(() => {
                    this.save('1')
                }).catch(() => {
                })
            },
            // 顶部返回按钮
            goBack() {
                this.emptyFormData()
                this.$refs["dataForm"].resetFields()
                this.$router.push({
                    name: "zone-competition-competitionManage"
                })
                this.$store.state.contentTabs.splice(this.$store.state.contentTabs.findIndex(item => item.path === this.$route.path), 1)
            },
            // 顶部编辑按钮
            goEdit(){

            },
            // 顶部下架按钮
            soldOut(){
                this.singleActionHandler("下架", "/competition/competitionManage/updateStatus", null,2)
            },


 /***************************************************专区************************************************************************/
            // 专区
            themeData() {
                this.isShow = true
                this.$nextTick(() => { this.$refs.multipleTable.clearSelection() })
                // 专区list取得
                this.themeFrom.page=1
                this.themeFrom.limit=10
                this.themeFrom.themeName = ''
                this.getDataList()
                this.getList()
            },
            // 被关联专区list取得
            getList(){
                var list = []
                this.$request
                    .get('/competition/competitionManage/selectAssociatedZone', {})
                    .then((res, total, code, data) => {
                        list = data.data
                        if(!this.isAdd) {
                            this.formData.managedata.associatedZone.forEach(item => {
                                list.splice(data.data.indexOf(item), 1)
                            })
                        }
                        this.themeFrom.list = list
                    })
                    .catch(() => {
                    })

            },

            getDataList() {
                this.dataListLoading = true
                // 专区list取得
                this.$request
                    .get('/grow/cocreationsharingmanage/getZoneList', {
                        page: this.themeFrom.page,
                        limit: this.themeFrom.limit,
                        name: this.themeFrom.themeName
                    })
                    .then((res, total, code, data) => {
                        this.dataListLoading = false
                        this.themeFrom.themeList = data.data.themeList
                        this.themeFrom.themeList.forEach((row) => {
                            row.createUserName = data.data.userMap[row.createBy].userName
                        })
                        this.themeFrom.page = data.data.pageNo
                        this.themeFrom.limit = data.data.pageSize
                        this.themeFrom.total = data.data.totalCount
                        if (this.formData.managedata.associatedZoneDTO && this.isShow) {
                            this.formData.managedata.associatedZoneDTO.forEach(data => {
                                this.themeFrom.themeList.forEach(row => {
                                    // 回显数据勾选
                                    if(data.id == row.id) {
                                        this.$nextTick(() => {
                                            this.$refs.multipleTable.toggleRowSelection(row, true)
                                        })
                                    }
                                })
                            })
                        }
                    })
                    .catch(() => {
                    })
            },
            // 勾选数据
            /*dataListSelectionChangeHandle (val) {
                console.log(val)
                // this.themeMultipleSelection = []
                for (let i = 0; i < val.length; i++) {
                    let theme = {}
                    theme.id = val[i].id
                    theme.name = val[i].name
                    theme.createUserName = val[i].createUserName
                    if (this.themeFrom.themeMultipleSelection.length>0) {
                        this.themeFrom.themeMultipleSelection.forEach(item=>{
                            console.log(item.id ,val[i].id)
                            if (item.id != val[i].id) {
                                this.themeFrom.themeMultipleSelection.push(theme)
                            }
                        })
                    }else {
                        this.themeFrom.themeMultipleSelection.push(theme)
                    }
                }
            },*/
            // 单选
            selectRedio (selection, row) {
                // 判断当前点击的是打钩还是取消打钩 true 则是打勾
                let isSelected = this.isExistRow(selection, row, 'id')
                if (isSelected) {
                    // 勾选
                    this.formData.managedata.associatedZoneDTO.push(row)
                } else {
                    // 取消勾选
                    for (let i in this.formData.managedata.associatedZoneDTO) {
                        if (this.formData.managedata.associatedZoneDTO[i].id === row.id) {
                            this.formData.managedata.associatedZoneDTO.splice(i, 1)
                        }
                    }
                }
            },
            // 全选
            selectRedioAll (selection) {
                console.log("全选数据："+selection+'_')
                if (selection) {
                    let courseDataB = []
                    courseDataB = this.formData.managedata.associatedZoneDTO
                    if (selection.length > 0) {
                        for (var i = 0; i < selection.length; i++) {
                            let hasFlg = false
                            if (courseDataB.length > 0) {
                                for (var l = 0; l < courseDataB.length; l++) {
                                    if (courseDataB[l].id.toString() === selection[i].id.toString()) {
                                        hasFlg = true
                                    }
                                }
                            }
                            if (!hasFlg) {
                                this.formData.managedata.associatedZoneDTO.push(selection[i])
                            }
                        }
                    } else {
                        if (this.formData.managedata.associatedZoneDTO.length > 0) {
                            this.themeFrom.themeList.forEach(item => {
                                let index = this.formData.managedata.associatedZoneDTO.findIndex(it => it.id.toString() === item.id.toString())
                                if (index != -1) {
                                    this.formData.managedata.associatedZoneDTO.splice(index,1)
                                }
                            })
                        }
                    }
                }
            },
            // 选
            isExistRow: function isExistRow (arrs, row, field) {
                let flag = false
                arrs.forEach(function (item) {
                    if (row[field] === item[field]) {
                        flag = true
                    }
                })
                return flag
            },
            // 专区选择
            selectTheme() {
                this.formData.managedata.associatedZoneDTO = JSON.parse(JSON.stringify(this.formData.managedata.associatedZoneDTO))
                console.log(this.formData.managedata.associatedZoneDTO)
                this.isShow = false
            },

            // 复选框不能选择
            checkboxT(row) {
                var f = true
                this.themeFrom.list.forEach(item=>{
                    if (item == row.id){
                        f = false
                    }
                })
                return f
            },

            handleClose2(theme) {
                this.formData.managedata.associatedZoneDTO.splice(this.formData.managedata.associatedZoneDTO.indexOf(theme), 1);
            },
            // 专区查找
            findTheme() {
                this.dataListLoading = true
                // 专区查找
                this.$request
                    .get('/grow/cocreationsharingmanage/getZoneList', {
                        page: 1,
                        limit: 10,
                        name: this.themeFrom.themeName
                    })
                    .then((res, total, code, data) => {
                        this.dataListLoading = false
                        this.themeFrom.themeList = data.data.themeList
                        this.themeFrom.themeList.forEach((row) => {
                            row.createUserName = data.data.userMap[row.createBy].userName
                        })
                        this.themeFrom.page = data.data.pageNo
                        this.themeFrom.limit = data.data.pageSize
                        this.themeFrom.total = data.data.totalCount
                    })
                    .catch(() => {
                    })
            },
            // 分页, 每页条数
            pageSizeChangeHandle (val) {
                this.themeFrom.page = 1
                this.themeFrom.limit = val
                this.getDataList()
            },
            // 分页, 当前页
            pageCurrentChangeHandle (val) {
                this.themeFrom.page = val
                this.getDataList()
            },
/********************************************************************************************************************/


            // 模块输入
            Input(){

            },
            // 标签输入
            handleClose(tag){
                this.formData.managedata.competitionTagDTOS.splice(tag,1);
                this.$forceUpdate();
            },
            handleClose3(tempTag) {
                this.tempTags.splice(this.tempTags.indexOf(tempTag), 1);
                this.$forceUpdate();
            },
            // 标签输入
            handleInputConfirm(){
                let inputValue = {
                    tagContent: '',
                }
                inputValue.tagContent = this.inputValue;
                if (inputValue.tagContent) {
                    if(inputValue.tagContent.charAt(0) !== '#') {
                        inputValue.tagContent = '#' + inputValue.tagContent
                    }
                    this.formData.managedata.competitionTagDTOS.push(inputValue)
                }
                this.inputValue = '';
            },
            // h5 文本选择
            radioChange(val,index) {
                console.log(val,index)
                if (val!==2) {
                    this.formData.managedata.competitionModuleDTOS[index].h5Url = ''
                }
                if (val!==1) {
                    this.formData.managedata.competitionModuleDTOS[index].competitionFiles = []
                }
                if (val!==3) {
                    this.formData.managedata.competitionModuleDTOS[index].startStopDate = []
                    this.formData.managedata.competitionModuleDTOS[index].groupDTOS = []
                    this.formData.managedata.competitionModuleDTOS[index].isRestriction = "2"
                }
            },

/*******************************************************************背景图上传***********************************************/
            // 背景图上传
            beforeImageUpload(file, index,i) {
                console.log("----index----",index,i)
                let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
                let uploadFormat = ['jpg', 'png', 'jpeg', 'JPG', 'PNG', 'JPEG']
                let falg = uploadFormat.indexOf(testmsg)
                if (falg === -1) {
                    this.$message.warning('只能上传jpg/png/jpeg文件')
                    return false
                }
                let isLt2M = file.size / 1024 / 1024 <= 20
                if (!isLt2M) {
                    this.$message.warning('上传图片大小不能超过20MB!')
                    return false
                }
                // 文件加密
                FileMd5(file, (e, md5) => {
                    file["md5"] = md5;
                    file.status = 1;
                });
                // 设置当前处理的图片顺序
                this.introduceIndexImg = index;
                this.textintroduceIndexImg = i;
            },
            // 1. 上传图片文件到云 切片
            imgUpload(data){
                var file = data.file
                var md5 = file.md5
                var size = file.size
                var chunks = Math.ceil(size/2097152)

                // 1. 先请求一个接口获取所有切片保存情况
                // 2. 循环发送请求
                // 3. 发现失败重试3次
                var uploadState = {
                    fileMd5:md5,
                    remarks:chunks,
                }
                this.$request.post('/grow/breakpointfile/appGetUploadState', uploadState).then((res, total, code, data) => {
                    // 结束
                    if(data.code === 1){
                        var checksAll = data.data.split('')
                        var chunk = 0
                        for (let i = 0; i < checksAll.length; i++) {
                            if(checksAll[i] === '0'){
                                chunk = i
                                break
                            }
                        }

                        // 开始分片上传
                        console.log(file)
                        this.upFile(file, chunk, chunks);
                    }else{
                        this.$message.error(data.msg)
                    }
                }).catch(() => {
                })
            },
            // 2. 上传切片文件
            upFile(file, i, chunks){
                var _this = this
                var name = file.name
                var md5 = file.md5
                var size = file.size

                var start = i * 2097152
                var end = 0
                if(i === (chunks-1)){
                    end = size
                }else {
                    end = (i+1) * 2097152
                }

                var part_file = file.slice(start,end);
                let formData = new FormData();
                formData.append('file', part_file )
                formData.append('name', name )
                formData.append('md5', md5 )
                formData.append('size', size )
                formData.append('chunk', i )
                formData.append('chunks', chunks )

                axios.post(this.server_config, formData,{
                    headers: {
                        'Content-Type': 'multipart/form-data;'
                    }
                }).then((res, total, code, data) => {
                    console.log(res)
                    if(res.data.code === 1){
                        var urlData = res.data.data
                        if(urlData !== null && urlData.indexOf('http') !== -1){
                            //上传后调用 成功回调接口
                            this.handleImgSuccess(file.name, urlData)
                        }else {
                            i ++
                            if(i < chunks){
                                _this.upFile(file, i, chunks)
                            }else {
                                //上传后调用 成功回调接口
                                this.handleImgSuccess(file.name, urlData)
                            }
                        }
                    }else {
                        this.$message.error(data.msg)
                    }
                }).catch(() => {
                })
            },
            //  3. 上传后调用 成功回调接口
            handleImgSuccess(fileName, fileUrl){
                if(this.textintroduceIndexImg === -1){
                    // 背景图
                    this.formData.managedata.competitionModuleDTOS[this.introduceIndexImg].backGround= fileUrl
                } else {
                    // 文本图
                    this.formData.managedata.competitionModuleDTOS[this.introduceIndexImg].competitionFiles[this.textintroduceIndexImg].fileUrl= fileUrl
                    this.formData.managedata.competitionModuleDTOS[this.introduceIndexImg].competitionFiles[this.textintroduceIndexImg].fileName= fileName
                }
            },

            //删除图片
            removeImg(){
                this.formData.managedata.fileName = ""
                this.formData.managedata.fileUrl = ""
            },
/*********************************************************************************************************************/




/**********************************************************上传视频***********************************************************/
            /** 子组件上传视频成功后调用的方法**/
            fileUrlData(val,index,i) {
                console.log("====index====",val,index,i)
                this.formData.managedata.competitionModuleDTOS[index].competitionFiles[i].fileUrl= val
                this.formData.managedata.competitionModuleDTOS[index].competitionFiles[i].fileCoverUrl= 'https://tasit.blob.core.chinacloudapi.cn/resource/8a7480997a05f56b017a139027980037cover.jpg'
                this.videoId = null
            },
            /*****子组件 开始上传/删除上传 调用的方法**/
            fileId(value){
                console.log('id======',value)
                this.videoId = value
            },
/*****************************************************************************************************************/



/************************************************上传视频头图*****************************************************************/
            /**上传视频头图按钮*/
            modifyCoverImg(index,i) {
                console.log(index,i)
                this.fileCoverUrlIntroduceIndexImg = i
                this.$refs.refImg.modifyCoverImg(index)
            },
            /**视频头图上传成功后调用的方法*/
            refreshCoverImg(data) {
                console.log('data',data)
                this.formData.managedata.competitionModuleDTOS[data.index].competitionFiles[this.fileCoverUrlIntroduceIndexImg].fileCoverUrl = data.url
                this.fileCoverUrlIntroduceIndexImg = -1
            },
/************************************************上传视频头图*****************************************************************/



            /*****删除话题介绍视频*****/
            delIntroduceVideo(index,i){
                console.log('删除视频',this.videoId)
                if (this.videoId) {
                    this.$refs.refVideo[index].deleteFileVideo(this.videoId)
                }
                this.formData.managedata.competitionModuleDTOS[index].competitionFiles.splice(i, 1)
            },
            //添加文本
            addText(index){
                this.formData.managedata.competitionModuleDTOS[index].competitionFiles.push(new Introduce("50"))
            },
            addImage(index){
                this.formData.managedata.competitionModuleDTOS[index].competitionFiles.push(new Introduce("10"))
            },
            // 添加视频
            addVideo(index){
                // this.$refs['introduce-video'].$children[0].$refs.input.click()
                var i = 0
                this.formData.managedata.competitionModuleDTOS.forEach((items,indexs)=>{
                    items.competitionFiles.forEach(item=>{
                        if (item.fileType === '20'&&item.fileUrl == '') {
                            i++
                        }
                    })
                })

                if (i == 0 ) {
                    this.formData.managedata.competitionModuleDTOS[index].competitionFiles.push(new Introduce("20"))
                }else {
                    this.$message.warning('请等待上一个视频上传完成!')
                }

            },
            delIntroduce(index,i){
                this.formData.managedata.competitionModuleDTOS[index].competitionFiles.splice(i, 1)
            },
            /*******************************************************参赛分组选择*************************************************************/

            // 选择不限制
            noRestriction(index) {
                // this.formData.managedata.competitionModuleDTOS[index].groupDTOS = []
            },
            // 选择按钮，打开弹窗
            selectGroup(val,index) {
                this.groupList = val
                this.dialogShowGroup = true
                this.indexGroup = index
            },
            // 取消
            closeGroup(value) {
                this.groupList = []
                this.dialogShowGroup = false
                this.indexGroup = 0
            },
            // 选择分组
            saveGroup(value) {
                console.log(value)
                this.formData.managedata.competitionModuleDTOS[this.indexGroup].groupDTOS = value
                this.groupList = []
                this.indexGroup = 0
            },
            // 删除分组
            delGroup(i,j) {
                console.log(i,j)
                console.log(this.formData.managedata.competitionModuleDTOS)
                var listData = this.formData.managedata.competitionModuleDTOS[i].groupDTOS
                listData.splice(j, 1);
                this.formData.managedata.competitionModuleDTOS[i].groupDTOS = listData
            },
            /**************************************************************************************************************************/
            // 添加模块
            addTemplate() {
                var template = {
                    moduleName: "", // 模块输入
                    backGround: "", // 添加图片
                    h5Url: "", //h5连接
                    moduleType: '2', // 选择h5还是文本
                    competitionFiles: [],
                    startStopDate: [],
                    isRestriction: '2',
                    groupDTOS: []
                }
                this.formData.managedata.competitionModuleDTOS.push(template)
            },
            // 删除模块
            delModule(index) {
                this.formData.managedata.competitionModuleDTOS.splice(index, 1)
            },
            // 清空表单
            emptyFormData() {
                var formData={
                        managedata:{
                            competitionCode: null, // 大赛id
                            associatedZoneDTO: [], // 专区id集合
                            associatedZone: "", // 专区id集合
                            competitionTagDTOS: [],   //标签集合
                            workStatus: "0",
                            competitionModuleDTOS:[{
                                moduleName: "", // 模块输入
                                backGround: "", // 添加图片
                                h5Url: "", //h5连接
                                moduleType: '2', // 选择h5还是文本
                                competitionFiles: [
                                ]
                            }]
                        },
                }
                this.formData = formData
            },
        }
    }

    //话题介绍对象
    function Introduce(type, content,index){
        this.fileName= ""  // 文件名称
        this.fileUrl=""  // 文本内容
        this.fileCoverUrl= ""  // 视频封面
        this.fileType= type  // 文本类
    }
</script>

<style lang="scss" scoped>

    .gray{
        margin-bottom: 16px !important;
    }
    .el-form-item{
        margin-bottom: 16px !important;
    }
    .search {
        text-align: right;
        margin-bottom: 0px;
    }

     .card1 .el-card__body {
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .pkg-content {
        background-color: #f9f9f9;
        position: relative;
    }

    .msg {
        margin: 0 50px;
        padding: 10px 0;
        position: relative;
    }

    .msg span {
        font-weight: 600;
        margin-right: 20px;
    }

    pre {
        white-space: normal;
        white-space: -moz-pre-wrap;
        white-space: -pre-wrap;
        white-space: -o-pre-wrap;
        word-wrap: break-word;
        font-family: BMWGlobalProReg, "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-size: 14px;
    }

    .introduce-list{
        margin-top: 20px;
        .introduce-item{

            .content{
                overflow: visible;
                position: relative;
                .remove-icon{
                    position: absolute;
                    right: -40px;
                    top: 5px;
                    /*z-index: 999999;*/
                    cursor: pointer;
                    font-size: 24px;
                    background-color: unset;
                    color: red;
                }
            }
            .remove-icon{
                margin: 5px;
                /*z-index: 999999;*/
                cursor: pointer;
                font-size: 24px;
                background-color: unset;
                color: red;
            }
            .content::before{
                content: "*";
                position: absolute;
                left: -12px;
                top: 50%;
                transform: translateY(-50%);
                color: red;
            }
            .content1::before{
                position: absolute;
                left: -12px;
                top: 50%;
                transform: translateY(-50%);
                color: red;
            }
            .content1 {
                margin-left: 5px;
            }
            margin-bottom: 20px;
        }
    }
    .media-warpper{
        position: relative;
        width: 220px;
        height: 100px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: center;
        border: solid 1px #e0e3e9;
        border-radius: 5px;
        overflow: hidden;
        .avatar-uploader-icon{
            font-size: 50px;
            color: #b5b5b5;
        }
        *{
            max-width: 100%;
            max-height: 100%;
        }
        .remove-icon{
            position: absolute;
            top: 0px;
            right: 0;
            background: #dfdfdf;
            padding: 0 8px;
        }
    }
    .bottom-btns{
        >*{
            cursor: pointer;
            margin-right: 20px;
            display: inline-flex;
            align-items: center;
        }
        >*::before{
            color: #67d58d;
            font-size: 22px;
            transform: translateY(1px);
            margin-right: 5px;
        }
    }
    // textarea字数提示
     .el-input__count{
        font-size: 12px !important;
    }

    .group-content {
        line-height: 32px;
        min-height: 44px;
        height: auto;
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        display: flex;
        flex-wrap: wrap;
        .group-card {
            background-color: #3278b4;
            font-size: 12px;
            height: 32px;
            color: #ffffff;
            margin: 5px;
            padding: 0 5px;
            border-radius: 4px;
            cursor: pointer;
            font-weight: normal;
            position: relative;
            .group-card-close {
                margin: 0px 0 0 5px;
                font-weight: 200;
            }
        }
    }
</style>
